import { renovatieContent } from "./content/renovatie";
import { uitbouwContent } from "./content/uitbouw";
import { kozijnenContent } from "./content/kozijnen";
import { afwerkingContent } from "./content/afwerking";
import { duurzaamheidContent } from "./content/duurzaamheid";

export const serviceContent = {
  ...renovatieContent,
  ...uitbouwContent,
  ...kozijnenContent,
  ...afwerkingContent,
  ...duurzaamheidContent,
};

export const getContent = (slug) => serviceContent[slug];
